function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icono_telf",
  stroke: "#000000",
  strokeWidth: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4285714,8.52571429 L11.4285714,10.24 C11.4298776,10.5617972 11.295456,10.8692333 11.0583302,11.0867799 C10.8212044,11.3043265 10.5033508,11.4118218 10.1828571,11.3828571 C8.4244765,11.1917947 6.73542809,10.5909397 5.25142857,9.62857143 C3.87075893,8.75123649 2.70019208,7.58066965 1.82285714,6.2 C0.857130319,4.70925942 0.256138858,3.01199689 0.0685714286,1.24571429 C0.0396989773,0.926212761 0.146441148,0.609287099 0.362723303,0.372354889 C0.579005458,0.135422679 0.884910995,0.000302108708 1.20571429,-5.61822531e-05 L2.92,-5.61822531e-05 C3.4936366,-0.00564580409 3.98257191,0.414838561 4.06285714,0.982857143 C4.13521315,1.53146654 4.26939969,2.07012965 4.46285714,2.58857143 C4.61984857,3.0062143 4.51943718,3.47703215 4.20571429,3.79428571 L3.48,4.52 C4.29346027,5.95059762 5.47797381,7.13511116 6.90857143,7.94857143 L7.63428571,7.22285714 C7.95153928,6.90913424 8.42235713,6.80872286 8.84,6.96571429 C9.35844178,7.15917174 9.89710488,7.29335828 10.4457143,7.36571429 C11.0203215,7.44677732 11.4429657,7.94559576 11.4285714,8.52571429 Z",
  id: "Path"
})));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono_telf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.72fb13af.svg";
export { ForwardRef as ReactComponent };